import { SvgIcon, type SvgIconProps } from '~/@mid_ui/icons/svgIcon'

export function NoDocumentsSvg({
  width = 600,
  height = 329,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        fill="#fff"
        d="M44.344 58.611c16.331 0 29.555-18.972 29.555-42.365 0 23.393 13.241 42.365 29.573 42.365-16.332 0-29.573 18.955-29.573 42.347 0-23.392-13.233-42.347-29.555-42.347z"></path>
      <path
        fill="#D9E2FB"
        d="M87.078 22.2c7.528 0 13.628-8.749 13.628-19.538 0 10.789 6.108 19.539 13.636 19.539-7.528 0-13.636 8.74-13.636 19.53 0-10.79-6.1-19.53-13.628-19.53z"></path>
      <path
        fill="#fff"
        d="M566.304 194.408a9.85 9.85 0 01-2.893 6.989l-3.117 3.108-13.978 13.987-13.978-13.987-3.117-3.108a9.85 9.85 0 01-2.893-6.989c0-5.462 4.429-9.89 9.891-9.89a9.85 9.85 0 016.989 2.892l3.108 3.108 3.117-3.108a9.85 9.85 0 016.989-2.892c5.462 0 9.882 4.428 9.891 9.89h-.009z"></path>
      <path
        fill="#E8E6E6"
        d="M90.749 279.877V179.156H11.292C5.058 179.156 0 184.214 0 190.448c0 3.117 1.267 5.929 3.306 7.977a11.304 11.304 0 007.986 3.306h45.437a2.684 2.684 0 012.677 2.677 2.688 2.688 0 01-2.677 2.695h-6.89c-3.27 0-5.92 2.65-5.92 5.911a5.92 5.92 0 005.92 5.92h15.182c4.357 0 7.896 3.54 7.896 7.896 0 2.183-.89 4.151-2.309 5.579a7.87 7.87 0 01-5.578 2.309H46.704c-12.46 0-22.575 10.106-22.575 22.575a22.487 22.487 0 006.62 15.954c4.088 4.096 9.72 6.621 15.955 6.621h44.054l-.01.009zM432.28 295.3a3.91 3.91 0 003.907 3.907h6.432c4.708 0 8.481 3.971 8.157 8.732-.296 4.339-4.096 7.618-8.444 7.618h-55.526c-4.5 0-8.165-3.656-8.165-8.175 0-2.246.916-4.294 2.398-5.767a8.143 8.143 0 015.767-2.399h26.474a3.91 3.91 0 003.908-3.907 3.911 3.911 0 00-3.908-3.908h-2.434c-9.873 0-18.38-7.465-19.099-17.302a18.6 18.6 0 015.435-14.615 18.635 18.635 0 0113.223-5.48h133.411c10.33 0 18.703 8.372 18.703 18.694 0 5.165-2.093 9.855-5.48 13.223a18.62 18.62 0 01-13.223 5.48H436.187a3.91 3.91 0 00-3.907 3.908v-.009zM546.318 68.23c0-12.927-10.492-23.42-23.446-23.42h-73.169v77.149h54.502c5.452 0 10.222-4.106 10.582-9.55.413-5.964-4.321-10.932-10.223-10.932h-8.067a4.894 4.894 0 01-4.887-4.896 4.886 4.886 0 014.887-4.887h26.384a23.299 23.299 0 0016.574-6.872 23.32 23.32 0 006.872-16.583l-.009-.01z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M296.266 8.682v255.484h185.549V8.682H296.266z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M146.734 71.96v255.483h59.658V71.96h-59.658z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M206.398 71.968V327.45H345.63V71.967H206.398z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M162.102 87.348v101.744h28.917V87.348h-28.917z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M162.102 98.873h28.917"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M176.563 312.072c7.983 0 14.454-6.471 14.454-14.454 0-7.983-6.471-14.454-14.454-14.454-7.982 0-14.454 6.471-14.454 14.454 0 7.983 6.472 14.454 14.454 14.454z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M179.638 311.757c-.988.216-2.012.323-3.081.323-7.977 0-14.463-6.485-14.463-14.463 0-7.977 6.486-14.463 14.463-14.463 1.06 0 2.093.108 3.081.324-6.504 1.41-11.382 7.195-11.382 14.13 0 6.935 4.878 12.712 11.382 14.131v.018zM220.422 253.086c0-1.294.521-2.461 1.365-3.297a4.655 4.655 0 013.297-1.365h24.336a4.656 4.656 0 014.653 4.662 4.637 4.637 0 01-1.365 3.297 4.602 4.602 0 01-3.288 1.365h-24.336a4.67 4.67 0 01-4.662-4.662z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M243.273 248.424h6.145a4.656 4.656 0 014.653 4.662 4.637 4.637 0 01-1.365 3.297 4.6 4.6 0 01-3.288 1.365h-6.145a4.599 4.599 0 003.288-1.365 4.634 4.634 0 001.366-3.297 4.656 4.656 0 00-4.654-4.662z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M220.422 146.32a4.62 4.62 0 011.365-3.296 4.652 4.652 0 013.297-1.366h24.336a4.656 4.656 0 014.653 4.662 4.636 4.636 0 01-1.365 3.297 4.6 4.6 0 01-3.288 1.366h-24.336a4.67 4.67 0 01-4.662-4.663z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M243.273 141.666h6.145a4.656 4.656 0 014.653 4.662 4.636 4.636 0 01-1.365 3.297 4.597 4.597 0 01-3.288 1.366h-6.145a4.596 4.596 0 003.288-1.366 4.632 4.632 0 001.366-3.297 4.656 4.656 0 00-4.654-4.662zM87.07 71.97v255.483h59.658V71.97H87.07z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M102.438 87.338v101.744h28.917V87.338h-28.917z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M102.438 98.873h28.917"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M116.892 312.072c7.982 0 14.454-6.471 14.454-14.454 0-7.983-6.472-14.454-14.454-14.454-7.983 0-14.454 6.471-14.454 14.454 0 7.983 6.471 14.454 14.454 14.454z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M119.974 311.759c-.988.216-2.012.323-3.081.323-7.977 0-14.463-6.486-14.463-14.463 0-7.977 6.486-14.463 14.463-14.463 1.06 0 2.093.108 3.081.324-6.504 1.41-11.382 7.195-11.382 14.13 0 6.935 4.878 12.712 11.382 14.131v.018zM287.055 27.114v255.484h185.549V27.114H287.055z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M277.844 17.9v255.483h185.549V17.899H277.844z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M323.613 87.168c13.922 0 25.207-11.286 25.207-25.207 0-13.922-11.285-25.207-25.207-25.207-13.921 0-25.207 11.285-25.207 25.207 0 13.921 11.286 25.207 25.207 25.207z"></path>
      <path
        fill="#3F6EEC"
        d="M339.221 58.988a7.721 7.721 0 00-7.717-7.716 7.66 7.66 0 00-5.452 2.263l-2.426 2.426-2.425-2.426a7.702 7.702 0 00-5.453-2.263 7.716 7.716 0 00-7.717 7.716c0 2.13.863 4.06 2.264 5.453l2.425 2.425 10.915 10.915 10.915-10.915 2.425-2.425a7.698 7.698 0 002.264-5.453h-.018zm-8.489 4.079l-7.187 7.186-4.366-4.366-2.209-2.21a2.325 2.325 0 01-.683-1.653 2.346 2.346 0 013.369-2.11c.233.116.449.269.628.449l2.255 2.254 1.006 1.007 1.105-1.105 2.767-2.767 2.426-2.426s.062-.072.098-.108a2.346 2.346 0 013.998 1.662 2.33 2.33 0 01-.683 1.653c-.036.036-.072.072-.108.1l-2.425 2.434h.009z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M449.703 36.754H389.82v8.058h59.883v-8.058zM414.685 117.342H298.406v8.058h116.279v-8.058z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M449.69 52.51h-22.979v8.058h22.979V52.51z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M298.406 140.023h116.279M298.406 151.396h68.902M298.406 162.77h91.423M298.406 174.133h23.168M298.406 196.869h84.91M298.406 208.242h90.192M298.406 219.605h53.603M298.406 230.979h92.474M298.406 242.344h101.978M87.074 327.451H48.742M520.153 327.451H345.617"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M497.736 309.493h-6.701l-4.582-5.947 36.58-69.351 11.283 5.956-36.58 69.342z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M540.292 238.678l-6.557 12.433a2.322 2.322 0 01-1.896 1.249h-6.71a2.32 2.32 0 001.895-1.249l.368-.701 6.19-11.723-14.176-7.483 1.465-2.766 19.421 10.24z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M533.581 238.678l-6.19 11.724-12.109-6.388a2.326 2.326 0 01-.979-3.153l5.093-9.666 14.176 7.483h.009z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M568.525 161.646c-20.85-10.995-46.686-3.009-57.682 17.841-10.995 20.85-3.009 46.686 17.841 57.681 20.85 10.996 46.686 3.01 57.682-17.84 10.995-20.851 3.009-46.686-17.841-57.682zm-36.715 69.593c-17.571-9.27-24.308-31.046-15.038-48.617 9.271-17.571 31.046-24.309 48.618-15.038 17.571 9.271 24.308 31.046 15.038 48.617-9.271 17.572-31.046 24.309-48.618 15.038zM527.595 240.139l-11.283-5.951-36.575 69.341 11.283 5.952 36.575-69.342z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M533.586 238.678l-6.189 11.723-.369.7a2.32 2.32 0 01-2.191 1.249 2.164 2.164 0 01-.953-.261l-15.307-8.075a2.335 2.335 0 01-.979-3.154l6.557-12.432 5.247 2.766 14.175 7.484h.009z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M561.806 161.646c-20.85-10.995-46.686-3.009-57.681 17.841-10.996 20.85-3.01 46.686 17.84 57.681 20.851 10.996 46.686 3.01 57.682-17.84 10.995-20.851 3.009-46.686-17.841-57.682zm-36.705 69.593c-17.572-9.27-24.309-31.046-15.038-48.617 9.27-17.571 31.046-24.309 48.617-15.038 17.571 9.271 24.309 31.046 15.038 48.617-9.271 17.572-31.046 24.309-48.617 15.038z"></path>
      <path
        stroke="#DBDADA"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M489.51 22.2V1h-65.955M107.543 64.287H79.398v77.283M587.39 167.216c-4.168-5.021-9.334-9.225-15.281-12.361M574.57 242.585a50.315 50.315 0 0018.587-19.682c3.144-5.947 5.03-12.334 5.632-18.829.602-6.495-.072-13.124-2.057-19.556M114.852 64.53h11.318M489.5 28.156v8.597M79.398 317.543v-28.072"></path>
    </SvgIcon>
  )
}
